let collator;
/**
 * Сравнение строк без учёта регистра и диакритических знаков
 * с учетом кириллической транслитерации
 * @param strA Строка слева
 * @param strB Строка справа
 * @returns Число, результат сравнения строк
 */
export const localCompare = (strA, strB) => {
    collator ??= new Intl.Collator(undefined, { sensitivity: 'base' });
    return collator.compare(strA, strB);
};
